import { SidebarRemoveProjectDialog } from "./SidebarRemoveProjectDialog";
import type { useSidebarProjectItem } from "./useSidebarProjectItem";

type SidebarProjectItemState = ReturnType<typeof useSidebarProjectItem>;

export function SidebarProjectRemovalDialogHost(props: {
  readonly state: SidebarProjectItemState;
  readonly projectName: string;
  readonly removesCloudRuntime: boolean;
  readonly cloudRegistrationProjectId: number | null;
}) {
  const { state } = props;
  if (!state.removeProjectDialogOpen) return null;
  return (
    <SidebarRemoveProjectDialog
      open
      onOpenChange={state.setRemoveProjectDialogOpen}
      projectName={props.projectName}
      removesCloudRuntime={props.removesCloudRuntime}
      isRemovingProject={state.isRemovalActivelyRunning}
      removalStepLabel={state.removalStepLabel}
      removalSummary={state.removalSummary}
      {...(state.fileRemovalTargets.length > 0
        ? {
            fileRemoval: {
              targets: state.fileRemovalTargets,
              previews: state.fileRemovalPreviews,
              results: state.fileRemovalResults,
              isPreviewing: state.isPreviewingFiles,
              onDeleteFilesChange: state.handleDeleteFilesChange,
            },
          }
        : {})}
      onConfirmRemove={(input) =>
        state.handleConfirmRemoveProject(
          { cloudRegistrationProjectId: props.cloudRegistrationProjectId },
          input,
        )
      }
    />
  );
}
